/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Images_Section_TitleInputs */

const vi_product_images_section_title = /** @type {(inputs: Product_Images_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình ảnh`)
};

/**

* @param {Product_Images_Section_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_images_section_title = /** @type {((inputs?: Product_Images_Section_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Images_Section_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_images_section_title(inputs)
});